module.exports = __webpack_public_path__ + "Roboto-Regular.766c8926f6d9061fef24.svg";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-Regular.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Regular.svg
// module chunks = 34